import API from '../../API';
import {
    setPens,
    setBadges,
    setIsLoading,
    setCategoryFilter,
    setCurrentDisplayLocale,
} from '../actionCreators/overview';

export function fetchPens(locale) {
    return dispatch => {
        dispatch(setIsLoading(true));
        API.getPens(locale).then(payload => {
            dispatch(setIsLoading(false));
            dispatch(setPens(payload.data.data));
        });
    };
}

export function fetchBadges() {
    return dispatch => {
        return API.getBadges().then(payload => {
            dispatch(setBadges(payload.data.data));
        });
    };
}

/**
 * call this with a  to reset
 * @param {int|undefined} categoryId
 * @return {function(*)}
 */
export function changeCategory(categoryId) {
    return dispatch => {
        let id = categoryId === undefined ? undefined : parseInt(categoryId, 10);
        dispatch(setCategoryFilter(id));
    };
}
